export const STATIC_UPPSALA_SVG_URL = 'https://static.uppsala.se/content/images/svg/';
